import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import {
    KYC_MODAL_ERROR_MISSING_DATA,
    KYC_MODAL_STEP_ERROR,
    KYC_MODAL_STEP_IN_PROGRESS,
    KYC_USE_CASE_WAITING_TRANSACTION
} from '../../../services/kyc/constants';
import { STATIC_ROOT } from '../../../constants';

import { initializeKyc, fetchKycState } from '../../../services/kyc/actions';

import { getLastUserInfoStored } from '../../../utils/storageUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

const KycStep1 = ({
    i18n,
    isAuthenticated,
    user,
    kycWidgetLink,
    fetchingLink,
    errorLink,
    initializeKyc,
    fetchKycState,
    setStep,
    setErrorType,
    useCase
}) => {
    useEffect(() => {
        if (kycWidgetLink) {
            setStep(KYC_MODAL_STEP_IN_PROGRESS);

            startCheckingKycState();
            window.open(kycWidgetLink, '_blank');
        } else if (errorLink) {
            setErrorType(KYC_MODAL_ERROR_MISSING_DATA);
            setStep(KYC_MODAL_STEP_ERROR);
        }
    }, [kycWidgetLink]);

    const getWidgetLink = () => {
        if (isAuthenticated && user) {
            const lastUserInfo = getLastUserInfoStored();
            const kycRequest = {
                firstname: lastUserInfo.firstname ? lastUserInfo.firstname : user.firstname,
                lastname: lastUserInfo.lastname ? lastUserInfo.lastname : user.lastname,
                mobileNumber: lastUserInfo.phoneNumber ? lastUserInfo.phoneNumber : user.phoneNumber
            };

            initializeKyc(kycRequest);
        } else {
            setErrorType(KYC_MODAL_ERROR_MISSING_DATA);
            setStep(KYC_MODAL_STEP_ERROR);
        }
    };

    const startCheckingKycState = () => {
        fetchKycState();
    };

    return (
        <div>
            <h3 className="banner">{i18n.TITLE}</h3>
            <div className="body">
                {useCase === KYC_USE_CASE_WAITING_TRANSACTION ? (
                    <p>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_1)}</p>
                ) : (
                    <p>{convertHtmlToReactDomWithParams(i18n.DEFAULT.TEXT_1)}</p>
                )}
                <p className="italic">{i18n.TEXT_2}</p>

                <div className="button-wrapper">
                    {fetchingLink ? (
                        <LoadingComponent />
                    ) : (
                        <ButtonComponent
                            color="main"
                            text={i18n.BUTTON_TEXT}
                            onClick={getWidgetLink}
                        />
                    )}
                </div>

                <p>{convertHtmlToReactDomWithParams(i18n.TEXT_3)}</p>
                <div className="ubble">
                    <div>{i18n.TEXT_4}</div>
                    <div>
                        <img
                            src={`${STATIC_ROOT}/kyc/ubble.png`}
                            alt={i18n.UBBLE_ALT}
                            width="100"
                            height="37"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.FRAUD.KYC_MODAL.STEP_1,
        isAuthenticated: state.authentication.isAuthenticated,
        user: user,
        kycWidgetLink: state.kyc.widgetLink,
        fetchingLink: state.kyc.fetchingLink,
        errorLink: state.kyc.errorLink
    };
};

const mapDispatchToProps = {
    initializeKyc,
    fetchKycState
};

export default connect(mapStateToProps, mapDispatchToProps)(KycStep1);



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycStep1.js